export const validationMessages = {
  FIELD_REQUIRED: "Bitte fülle dieses Feld aus.",
  EMAIL_NOT_VALID: "Eingabe entspricht nicht dem vorgegebenen Email Format.",
  FILE_WRONG_TYPE: "Es dürfen nur PDF Dateien hochgeladen werden.",
  FILE_WRONG_SIZE: "Die Datei darf nicht größer als 10 MB sein.",
  FILE_WRONG_COUNT: "Es darf nur eine Datei hochgeladen werden.",
  SELECTION_REQUIRED: "Bitte eine Option auswählen.",
  DECLARATION_REQUIRED: "Bitte stimmen sie den Datenschutz Bestimmungen zu.",
  TOO_MANY_CHARACTERS_INPUT: "Die Eingabe darf 50 Zeichen nicht überschreiten.",
  TOO_MANY_CHARACTERS_TEXTAREA:
    "Die Eingabe darf 1000 Zeichen nicht überschreiten.",
};
